import { FactoryBase } from './factoryBase';

import type { EntityDataPubType } from './entityBase';
import type { EntityDataPubNotNullType } from './entityPub';
import type { EntityDataBaseType } from '@/types/common/entityBase';

/**
 * Entityの抽象クラス.以下を実装してください.
 * - create(props: P, propsPub: EntityPubNotNullType< PP >): E;
 * - createFromEntityDataPub(props: EntityDataPubNotNullType<J, JP>): E
 */
export abstract class FactoryPub<E, P, J, PP, JP> extends FactoryBase<E, P, J, PP, JP> {
  /**
   * createFromEntityDataPub
   * @param props props
   */
  abstract createFromEntityDataPub(props: EntityDataPubNotNullType<J, JP>): E

  /**
   * Jsonを比較する
   * @param a 対象1
   * @param b 対象2
   */
  abstract comparePub(
    a: EntityDataPubNotNullType<J, JP>,
    b: EntityDataPubNotNullType<J, JP>,
  ): number

  /**
   * Jsonを比較する
   * @param a 対象1
   * @param b 対象2
   * @returns 差分
   */
  compare = (
    a: EntityDataBaseType<J, JP>,
    b: EntityDataBaseType<J, JP>,
  ) => {
    if (a.pub && b.pub) {
      return this.comparePub(
        a as EntityDataPubNotNullType<J, JP>,
        b as EntityDataPubNotNullType<J, JP>,
      );
    }
    throw new Error('pubに値がありません.(Error in FactoryPub comparePub)');
  };

  /**
   * JSONから生成
   * @param props プロパティ
   * @returns Entity
   */
  createFromJson(props: EntityDataPubType<J, JP>): E {
    if (props.pub) {
      return this.createFromEntityDataPub({
        data: props.data,
        pub: props.pub,
      });
    }
    throw new Error('pubに値がありません.(Error in FactoryPub)');
  }
}
